import { render, staticRenderFns } from "./labeladd.vue?vue&type=template&id=55360b80&scoped=true&"
import script from "./labeladd.vue?vue&type=script&lang=js&"
export * from "./labeladd.vue?vue&type=script&lang=js&"
import style0 from "./labeladd.vue?vue&type=style&index=0&id=55360b80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55360b80",
  null
  
)

export default component.exports